import React, { useState } from "react";
import { Col, Form, Row, Input, Button, Radio, Tooltip } from "antd";
import { Helmet } from "react-helmet";

import CalculatorBanner from "../../../components/website/CalculatorBanner/CalculatorBanner";
import { CalculatorLinks } from "../../../components/website/CalculatorLinks/CalculatorLinks";
import { CalculatorResult } from "../../../components/website/CalculatorResult/CalculatorResult";
import { CalculatorContent } from "../../../components/website/CalculatorContent/CalculatorContent";

import "../../../assets/styles/calculator.css";

/* CALCULADORA RISCO CV GLOBAL SCORE2 */
const CalculatorCVGlobalSCORE2Page = () => {
  const [errorFinded, setErrorFinded] = useState(null);
  const [message, setMessage] = useState(null);
  const [percentage, setPercentage] = useState(null);
  const [colorResult, setColorResult] = useState("");
  const [minValues] = useState({
    age: 40,
    tas: 100,
    cholesterol: 116,
    cholesterolHDL: 27,
  });
  const [maxValues] = useState({
    age: 69,
    tas: 200,
    cholesterol: 348,
    cholesterolHDL: 97,
  });
  const [isResultLoading, setIsResultLoading] = useState(false);

  const [transformedValues] = useState({
    sex: null,
    age: null,
    smoke: null,
    tas: null,
    cholesterol: null,
    cholesterolHDL: null,
    smoking_age: null,
    tas_age: null,
    ct_age: null,
    hdl_age: null,
  });

  const [finalValues] = useState({
    sex: null,
    age: null,
    smoke: null,
    tas: null,
    cholesterol: null,
    cholesterolHDL: null,
    smoking_age: null,
    tas_age: null,
    ct_age: null,
    hdl_age: null,
  });

  const [form] = Form.useForm();

  const handleValuesChange = () => {
    let allValues = form.getFieldsValue();
    let columns = Object.keys(allValues);

    let nullItems = 0;
    let auxErrorsFinded = 0;

    for (let i = 0; i < columns.length; i++) {
      if (typeof allValues[columns[i]] === "string") {
        allValues[columns[i]] = Number(allValues[columns[i]]);
      }

      if (allValues[columns[i]] === null || allValues[columns[i]] === undefined) {
        nullItems++;
      }
    }

    if (nullItems === 0) {
      const validationErrors = Object.values(form.getFieldsError());

      for (let e = 0; e < validationErrors.length; e++) {
        if (validationErrors[e].errors.length > 0) {
          auxErrorsFinded++;
        }
      }
    }

    if (nullItems === 0 && auxErrorsFinded === 0) {
      let auxTransformedValue = transformedValues;
      let auxFinalValues = finalValues;

      auxTransformedValue.sex = allValues.sex;

      auxTransformedValue.age = (allValues.age - 60) / 5;

      auxTransformedValue.smoke = allValues.smoke;

      auxTransformedValue.tas = (allValues.tas - 120) / 20;

      auxTransformedValue.cholesterol = allValues.cholesterol * 0.02586;
      auxTransformedValue.cholesterol = (auxTransformedValue.cholesterol - 6) / 1;

      auxTransformedValue.cholesterolHDL = allValues.cholesterolHDL * 0.02586;
      auxTransformedValue.cholesterolHDL = (auxTransformedValue.cholesterolHDL - 1.3) / 0.5;

      auxTransformedValue.smoking_age = auxTransformedValue.age * auxTransformedValue.smoke;

      auxTransformedValue.tas_age = auxTransformedValue.age * auxTransformedValue.tas;
      auxTransformedValue.ct_age = auxTransformedValue.age * auxTransformedValue.cholesterol;
      auxTransformedValue.hdl_age = auxTransformedValue.age * auxTransformedValue.cholesterolHDL;

      if (auxTransformedValue.sex === 1) {
        //MASCULINO
        auxFinalValues.age = 0.3742 * auxTransformedValue.age;
        auxFinalValues.smoke = 0.6012 * auxTransformedValue.smoke;
        auxFinalValues.tas = 0.2777 * auxTransformedValue.tas;
        auxFinalValues.cholesterol = 0.1458 * auxTransformedValue.cholesterol;
        auxFinalValues.cholesterolHDL = -0.2698 * auxTransformedValue.cholesterolHDL;
        auxFinalValues.smoking_age = -0.0755 * auxTransformedValue.smoking_age;
        auxFinalValues.tas_age = -0.0255 * auxTransformedValue.tas_age;
        auxFinalValues.ct_age = -0.0281 * auxTransformedValue.ct_age;
        auxFinalValues.hdl_age = 0.0426 * auxTransformedValue.hdl_age;

        let sumOfFinalValues =
          auxFinalValues.age +
          auxFinalValues.smoke +
          auxFinalValues.tas +
          auxFinalValues.cholesterol +
          auxFinalValues.cholesterolHDL +
          auxFinalValues.smoking_age +
          auxFinalValues.tas_age +
          auxFinalValues.ct_age +
          auxFinalValues.hdl_age;

        let tenYearsRisk = 1 - Math.pow(0.9605, Math.exp(sumOfFinalValues));

        let calibrationModeratedRisk = 1 - Math.exp(-Math.exp(-0.1565 + 0.8009 * Math.log(-Math.log(1 - tenYearsRisk))));

        let calibrationModeratedRiskPercentage = calibrationModeratedRisk * 100;
        calibrationModeratedRiskPercentage = calibrationModeratedRiskPercentage.toFixed(1);
        calibrationModeratedRiskPercentage = parseFloat(calibrationModeratedRiskPercentage);
        setPercentage(calibrationModeratedRiskPercentage);

        /* SHOW MESSAGE */
        let age = parseInt(allValues.age);

        if (age < 50) {
          if (calibrationModeratedRiskPercentage < 2.5) {
            setMessage(`Baixo a moderado`);
            setColorResult("yellow");
          } else if (calibrationModeratedRiskPercentage >= 2.5 && calibrationModeratedRiskPercentage < 7.5) {
            setMessage(`Alto`);
            setColorResult("orange");
          } else {
            setMessage(`Muito alto`);
            setColorResult("red");
          }
        } else if (age >= 50 && age < 70) {
          if (calibrationModeratedRiskPercentage < 5) {
            setMessage(`Baixo a moderado`);
            setColorResult("yellow");
          } else if (calibrationModeratedRiskPercentage >= 5 && calibrationModeratedRiskPercentage < 10) {
            setMessage(`Alto`);
            setColorResult("orange");
          } else {
            setMessage(`Muito alto`);
            setColorResult("red");
          }
        } else if (age >= 70) {
          setMessage(`CONSULTE A SCORE2-OP`);
        } else {
          setMessage(`ALGUMA COISA SE PASSOU...`);
        }
      } else {
        //FEMININO
        auxFinalValues.age = 0.4648 * auxTransformedValue.age;
        auxFinalValues.smoke = 0.7744 * auxTransformedValue.smoke;
        auxFinalValues.tas = 0.3131 * auxTransformedValue.tas;
        auxFinalValues.cholesterol = 0.1002 * auxTransformedValue.cholesterol;
        auxFinalValues.cholesterolHDL = -0.2606 * auxTransformedValue.cholesterolHDL;
        auxFinalValues.smoking_age = -0.1088 * auxTransformedValue.smoking_age;
        auxFinalValues.tas_age = -0.0277 * auxTransformedValue.tas_age;
        auxFinalValues.ct_age = -0.0226 * auxTransformedValue.ct_age;
        auxFinalValues.hdl_age = 0.0613 * auxTransformedValue.hdl_age;

        let sumOfFinalValues =
          auxFinalValues.age +
          auxFinalValues.smoke +
          auxFinalValues.tas +
          auxFinalValues.cholesterol +
          auxFinalValues.cholesterolHDL +
          auxFinalValues.smoking_age +
          auxFinalValues.tas_age +
          auxFinalValues.ct_age +
          auxFinalValues.hdl_age;

        let tenYearsRisk = 1 - Math.pow(0.9776, Math.exp(sumOfFinalValues));

        let calibrationModeratedRisk = 1 - Math.exp(-Math.exp(-0.3143 + 0.7701 * Math.log(-Math.log(1 - tenYearsRisk))));

        let calibrationModeratedRiskPercentage = calibrationModeratedRisk * 100;
        calibrationModeratedRiskPercentage = calibrationModeratedRiskPercentage.toFixed(1);
        calibrationModeratedRiskPercentage = parseFloat(calibrationModeratedRiskPercentage);
        setPercentage(calibrationModeratedRiskPercentage);

        /* SHOW MESSAGE */
        let age = parseInt(allValues.age);

        if (age < 50) {
          if (calibrationModeratedRiskPercentage < 2.5) {
            setMessage(`Baixo a moderado`);
            setColorResult("yellow");
          } else if (calibrationModeratedRiskPercentage >= 2.5 && calibrationModeratedRiskPercentage < 7.5) {
            setMessage(`Alto`);
            setColorResult("orange");
          } else {
            setMessage(`Muito alto`);
            setColorResult("red");
          }
        } else if (age >= 50 && age < 70) {
          if (calibrationModeratedRiskPercentage < 5) {
            setMessage(`Baixo a moderado`);
            setColorResult("yellow");
          } else if (calibrationModeratedRiskPercentage >= 5 && calibrationModeratedRiskPercentage < 10) {
            setMessage(`Alto`);
            setColorResult("orange");
          } else {
            setMessage(`Muito alto`);
            setColorResult("red");
          }
        } else if (age >= 70) {
          setMessage(`CONSULTE A SCORE2-OP`);
          // red
        } else {
          setMessage(`ALGUMA COISA SE PASSOU...`);
        }
      }

      setIsResultLoading(false);
      setErrorFinded(false);
    } else {
      if (auxErrorsFinded > 0) {
        setPercentage(null);
        setErrorFinded(true);
      }
      setMessage(null);
    }
  };

  function handleIncrement(key) {
    let value = form.getFieldValue(key);
    if (typeof value === "string") {
      value = Number(value);
    }

    if (value) {
      if (value >= minValues[key] && value < maxValues[key]) {
        value++;
      } else if (value < minValues[key]) {
        value = minValues[key];
      } else {
        value = maxValues[key];
      }

      form.setFieldValue([key], Number(value));
      form.validateFields([key]);
    } else {
      form.setFieldValue([key], minValues[key]);
      form.validateFields([key]);
    }
  }

  function handleDecrement(key) {
    let value = form.getFieldValue(key);
    if (typeof value === "string") {
      value = Number(value);
    }

    if (value) {
      if (value > minValues[key] && value <= maxValues[key]) {
        value--;
      } else if (value <= minValues[key]) {
        value = minValues[key];
      } else {
        value = maxValues[key];
      }

      form.setFieldValue([key], Number(value));
      form.validateFields([key]);
    } else {
      form.setFieldValue([key], minValues[key]);
      form.validateFields([key]);
    }
  }

  function handleValidate(rule, value) {
    let key = rule.field;
    let keysOfNumber = Object.keys(minValues);
    if (keysOfNumber.includes(key)) {
      if (Number(value) < minValues[rule.field]) {
        return Promise.reject(<Tooltip color="red" placement="bottom" open={true} title={`Este valor não pode ser menor que ${minValues[rule.field]}`}></Tooltip>); // The validator should always return a promise on both success and error
      } else if (Number(value) > maxValues[rule.field]) {
        return Promise.reject(<Tooltip color="red" placement="bottom" open={true} title={`Este valor não pode ser maior que ${maxValues[rule.field]}`}></Tooltip>); // The validator should always return a promise on both success and error
      } else {
        return Promise.resolve(); // The validator should always return a promise on both success and error
      }
    }
  }

  return (
    <>
      <Helmet>
        <title>Calculadora RISCO CV GLOBAL SCORE2 | Formação Científica em Medicina Cardiovascular</title>
        <meta
          name="description"
          content="O objetivo Cardio4all é trazer formação científica de alta qualidade, que seja eminentemente prática clínica e interativa, para ajudar os clínicos a melhorarem o diagnóstico e tratamento das doenças cardiovasculares."
        />
        <meta
          name="keywords"
          content="calculadoras área cardiovascular, Cardio4all, Medicina Cardiovascular, formação científica médica, prática clínica cardiologia, doenças cardiovasculares, formação médica em Medicina Geral e Familiar e de Medicina Interna, diagnóstico e tratamento da doença cardiovascular"
        />
        <meta property="og:title" content="Calculadora RISCO CV GLOBAL SCORE2 | Formação Científica em Medicina Cardiovascular" />
        <meta
          property="og:description"
          content="O objetivo Cardio4all é trazer formação científica de alta qualidade, que seja eminentemente prática clínica e interativa, para ajudar os clínicos a melhorarem o diagnóstico e tratamento das doenças cardiovasculares."
        />
      </Helmet>
      <CalculatorBanner title="RISCO CV GLOBAL SCORE2" />

      <CalculatorContent className="mt-10">
        <Form className="form_calculator" form={form} onFieldsChange={handleValuesChange}>
          {/* Row #1 */}
          <Row
            gutter={[
              { xs: 20, sm: 8, md: 16, lg: 60 },
              { xs: 40, sm: 8, md: 16, lg: 60 },
            ]}
            className="mb-40"
          >
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Sexo</p>
              <Form.Item name={"sex"} className="mt-10 w-100 mb-0">
                <Radio.Group className="w-100 d-flex flex-nowrap">
                  <Radio.Button value={0} className="w-100 mr-10">
                    Feminino
                  </Radio.Button>
                  <Radio.Button value={1} className="w-100 ml-10">
                    Masculino
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Idade</p>
              <Row className="mt-10 d-flex flex-nowrap">
                <Button onClick={() => handleDecrement("age")} className="calculator_button mr-10">
                  -
                </Button>
                <Form.Item name={"age"} className="w-100 mb-0" rules={[{ validator: handleValidate }]}>
                  <Input type="number" className="w-100" />
                </Form.Item>
                <Button onClick={() => handleIncrement("age")} className="calculator_button ml-10">
                  +
                </Button>
              </Row>
              <p className="f-14 mt-10">Valor entre: 40 - 69</p>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Fumador</p>
              <Form.Item name={"smoke"} className="mt-10 w-100 mb-0">
                <Radio.Group className="w-100 d-flex flex-nowrap">
                  <Radio.Button value={1} className="w-100 mr-10">
                    Sim
                  </Radio.Button>
                  <Radio.Button value={0} className="w-100 ml-10">
                    Não
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>

            {/* Row #2 */}
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Tensão arterial sistólica (mmHg)</p>
              <Row className="mt-10 d-flex flex-nowrap">
                <Button onClick={() => handleDecrement("tas")} className="calculator__button mr-10">
                  -
                </Button>
                <Form.Item name={"tas"} className="w-100 mb-0" rules={[{ validator: handleValidate }]}>
                  <Input type="number" className="w-100" />
                </Form.Item>
                <Button onClick={() => handleIncrement("tas")} className="calculator__button ml-10">
                  +
                </Button>
              </Row>
              <p className="f-14 mt-10">Valor entre: 100 - 200</p>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Colesterol total (mg/dL)</p>
              <Row className="mt-10 d-flex flex-nowrap">
                <Button onClick={() => handleDecrement("cholesterol")} className="calculator__button mr-10">
                  -
                </Button>
                <Form.Item name={"cholesterol"} className="w-100 mb-0" rules={[{ validator: handleValidate }]}>
                  <Input type="number" className="w-100" />
                </Form.Item>
                <Button onClick={() => handleIncrement("cholesterol")} className="calculator__button ml-10">
                  +
                </Button>
              </Row>
              <p className="f-14 mt-10">Valor entre: 116 - 348</p>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Colesterol HDL (mg/dL)</p>
              <Row className="mt-10 d-flex flex-nowrap">
                <Button onClick={() => handleDecrement("cholesterolHDL")} className="calculator__button mr-10">
                  -
                </Button>
                <Form.Item name={"cholesterolHDL"} className="w-100 mb-0" rules={[{ validator: handleValidate }]}>
                  <Input type="number" className="w-100" />
                </Form.Item>
                <Button onClick={() => handleIncrement("cholesterolHDL")} className="calculator__button ml-10">
                  +
                </Button>
              </Row>
              <p className="f-14 mt-10">Valor entre: 27 - 97</p>
            </Col>
          </Row>
        </Form>
      </CalculatorContent>

      {percentage && (
        <CalculatorResult isLoading={isResultLoading}>
          <Row className="h-100 ai-start jc-start">
            <Col xs={24} sm={24} md={14} lg={14} xl={14}>
              <p>Resultado:</p>
              <div className="d-flex ai-center mt-20">
                <div className={`circle_calc ${colorResult} mr-20`}></div>
                <div className="d-flex flex-column">
                  <p className="f-30 bold text-uppercase">{percentage}%</p>
                  <p className="f-30 bold text-uppercase">{message}</p>
                </div>
              </div>
            </Col>
            {form.getFieldValue("age") < 50 && (
              <Col xs={24} sm={24} md={10} lg={10} xl={10} className="d-flex flex-column jc-center ai-center mt-10">
                <Row gutter={[24]}>
                  <div className="d-flex ai-center">
                    <div className="circle_calc yellow"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score < 2,5%: "} grau BAIXO A MODERADO</p>
                    </div>
                  </div>
                </Row>
                <Row gutter={[24]} className="mt-15">
                  <div className="d-flex ai-center">
                    <div className="circle_calc orange"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score 2,5 - 7,4%: "} grau ALTO</p>
                    </div>
                  </div>
                </Row>
                <Row gutter={[24]} className="mt-15">
                  <div className="d-flex ai-center">
                    <div className="circle_calc red"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score ≥ 7,5%:"} grau MUITO ALTO</p>
                    </div>
                  </div>
                </Row>
              </Col>
            )}

            {form.getFieldValue("age") >= 50 && form.getFieldValue("age") < 70 && (
              <Col xs={24} sm={24} md={10} lg={10} xl={10} className="d-flex flex-column jc-center ai-center mt-10">
                <Row gutter={[24]}>
                  <div className="d-flex ai-center">
                    <div className="circle_calc yellow"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score < 5%: "} grau BAIXO A MODERADO</p>
                    </div>
                  </div>
                </Row>
                <Row gutter={[24]} className="mt-15">
                  <div className="d-flex ai-center">
                    <div className="circle_calc orange"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score 5 - 9,9%: "} grau ALTO</p>
                    </div>
                  </div>
                </Row>
                <Row gutter={[24]} className="mt-15">
                  <div className="d-flex ai-center">
                    <div className="circle_calc red"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score ≥ 10%:"} grau MUITO ALTO</p>
                    </div>
                  </div>
                </Row>
              </Col>
            )}

            {form.getFieldValue("age") >= 70 && (
              <Col xs={24} sm={24} md={10} lg={10} xl={10} className="d-flex flex-column jc-center ai-center mt-10">
                <Row gutter={[24]}>
                  <div className="d-flex ai-center">
                    <div className="circle_calc yellow"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score < 7,5%: "} grau BAIXO A MODERADO</p>
                    </div>
                  </div>
                </Row>
                <Row gutter={[24]} className="mt-15">
                  <div className="d-flex ai-center">
                    <div className="circle_calc orange"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score 7,5 - 14,9%: "} grau ALTO</p>
                    </div>
                  </div>
                </Row>
                <Row gutter={[24]} className="mt-15">
                  <div className="d-flex ai-center">
                    <div className="circle_calc red"></div>
                    <div className="ml-10">
                      <p className="m-0">{"Score ≥ 15%:"} grau MUITO ALTO</p>
                    </div>
                  </div>
                </Row>
              </Col>
            )}
          </Row>
        </CalculatorResult>
      )}

      {errorFinded && (
        <CalculatorResult isLoading={isResultLoading}>
          <Row gutter={[24, 24]} className="h-100 ai-center jc-center">
            <Col xs={24} sm={24} md={16} lg={16} xl={16} className="d-flex jc-center ai-center">
              <p className="f-20 text-center">Algum valor não está entre os parâmetros requeridos</p>
            </Col>
          </Row>
        </CalculatorResult>
      )}

      <CalculatorLinks />
    </>
  );
};
export default CalculatorCVGlobalSCORE2Page;
